import { cn } from "@synthesis/shared-utils";

import type { CreateApplicationDocumentTableRow, CreateApplicationDocumentUploadHandlers } from "../../create-application-page.lib";
import { CreateApplicationDocumentRow } from "./create-application-document-row";

type CreateApplicationDocumentsListProps = {
  documents: CreateApplicationDocumentTableRow[];
  className?: string;
} & CreateApplicationDocumentUploadHandlers;

export const CreateApplicationDocumentsList = ({ documents, className, onUploadClick, onRemoveFile }: CreateApplicationDocumentsListProps) => (
  <div className={cn("flex w-full flex-col", className)}>
    <div className="flex w-full">
      <div className="bg-neutrals-99 border-neutrals-90 flex w-12 shrink-0 border-b border-r px-4 py-3">
        <span className="paragraph-sm text-type-minor">№</span>
      </div>
      <div className="bg-neutrals-99 border-neutrals-90 flex min-w-0 flex-1 border-b px-4 py-3">
        <span className="paragraph-sm text-type-minor">Наименование документа, загруженный файл</span>
      </div>
    </div>

    {documents.map((document) => (
      <CreateApplicationDocumentRow key={document.id} {...document} onUploadClick={onUploadClick} onRemoveFile={onRemoveFile} />
    ))}
  </div>
);
